<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Lektionen</h1>
                <p class="h2">Wöchentliche Lektionen unterstützen die Nutzenden bei den wichtigsten Grundlagen</p>
            </div>
            <div class="right-wrapper">
                <h2>Evidenzbasierte Informationsquelle</h2>
                <p class="text">Evidenzbasierte und verständliche Informationen.</p>                
                <p class="text">Während das Internet Patientinnen und Patienten mit unzähligen Diäten bombardiert, die Wunder versprechen, hält Vitadio sich an wissenschaftlich fundierte Grundsätze.</p>
                <p class="text">Die wöchentlichen Lektionen helfen den Nutzenden dabei, endlich den Zusammenhang zwischen Blutzuckerspiegel und Lebensstil zu verstehen.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 16
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

